import {
  Form, FormProps, FormSubmitType,
} from '@doveit/bricks';
import React from 'react';
import { INPUT_PLACEHOLDERS } from '../../../constants';
import FormGeoField from '../../../geo/components/form-geo-field/FormGeoField';
import { GeoFormModel } from '../../../geo/components/form-geo-field/types';

export interface WizardCompanyFormModel {
  companyName: string,
  companyAddress?: GeoFormModel,
  companyFiscalCode: string,
}

export interface WizardCompanyFormProps extends React.PropsWithChildren {
  initialValues?: Partial<WizardCompanyFormModel>,
  loading?: FormProps<WizardCompanyFormModel>['loading'],
  disabled?: FormProps<WizardCompanyFormModel>['disabled'],
  onSubmit: FormSubmitType<WizardCompanyFormModel>,
  formRef: FormProps<WizardCompanyFormModel>['innerRef'],
}

const DEFAULT_INITIAL_VALUES: WizardCompanyFormModel = {
  companyName: '',
  companyFiscalCode: '',
};

const WizardCompanyForm: React.FC<WizardCompanyFormProps> = ({
  initialValues = {},
  formRef,
  ...rest
}) => {
  const mergedInitialValues: WizardCompanyFormModel = React.useMemo(() => ({
    ...DEFAULT_INITIAL_VALUES,
    ...initialValues,
  }), [initialValues]);

  return (
    <Form
      initialValues={mergedInitialValues}
      innerRef={formRef}
      enableReinitialize
      {...rest}
    >
      <Form.Item size={{ MD: 1 / 2 }}>
        <Form.Input
          name="companyName"
          label="Ragione sociale"
          aria-label="Campo per inserire la ragione sociale"
          required
          placeholder={INPUT_PLACEHOLDERS.COMPANY_NAME}
        />
      </Form.Item>
      <Form.Item size={{ MD: 1 / 2 }}>
        <Form.Input
          name="companyFiscalCode"
          label="Partita IVA"
          aria-label="Campo per inserire la partita IVA"
          required
          placeholder={INPUT_PLACEHOLDERS.COMPANY_VAT_NUMBER}
        />
      </Form.Item>
      <Form.Item>
        <FormGeoField
          name="companyAddress"
          enableManualEntry
        />
      </Form.Item>
    </Form>
  );
};

export default WizardCompanyForm;
